import * as TYPES from "../types";

export default (state = {summary: {}, sensors: [], entity: [], dPackets: [], packetGraph: []}, action) => {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case TYPES.REPLACE_SUMMARY_DATA:
      newState.summary = {...action.summary};
      return newState;
    case TYPES.REPLACE_SENSORS_DATA:
      newState.sensors = [...action.sensors];
      return newState;
    case TYPES.REPLACE_ENTITY_DATA:
      newState.entity = [...action.entity];
      return newState;
    case TYPES.REPLACE_D_PACKET_DATA:
      newState.dPackets = [...action.dPackets];
      return newState;
    case TYPES.REPLACE_PACKET_GRAPH:
      newState.packetGraph = [...action.data];
      return newState;
    default:
      return state;
  }
};
